import { createListSlice } from 'redux/utils'

const slice = createListSlice('Collection')
export const { actions } = slice
export default slice.reducer
